"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'tools.detectTasks.name': 'Task Detection',
    'tools.detectTasks.description': 'Automatically detects and extracts task information from user messages',
};
